import { HISTORY_WINDOWS } from './collectionHistory';
import { isDiscoveryDateCapability } from './discoveryDates';

// With a common monitoring_period, the backend derives these provider request
// windows at evaluation time. They are not independently selected user scope.
const serverWindows = {
    'reddit.posts.discover_by_keyword': { key: 'post_window', values: HISTORY_WINDOWS },
    'meta.ads.discover_by_advertiser': { key: 'advertiser_period', values: ['last24h', 'last7d', 'last14d', 'last30d', 'all'] },
} as const;

export function monitoringChannelOptionMatches(
    capability: string, key: string, requested: unknown, actual: unknown, hasMonitoringPeriod: boolean,
): boolean {
    const window = serverWindows[capability as keyof typeof serverWindows];
    return hasMonitoringPeriod && window?.key === key
        ? (window.values as readonly unknown[]).includes(actual)
        : requested === actual;
}

/** Call only when the selected common period itself is compared separately. */
export function comparableMonitoringScope(scope: unknown): unknown {
    if (!scope || typeof scope !== 'object' || Array.isArray(scope)) return scope;
    const result = { ...scope } as Record<string, unknown>;
    const capability = String(result.capability);
    const window = serverWindows[capability as keyof typeof serverWindows];
    if (window) delete result[window.key];
    if (isDiscoveryDateCapability(capability)) {
        delete result.discovery_start_date;
        delete result.discovery_end_date;
    }
    return result;
}
